module.exports = __webpack_public_path__ + "static/media/live-lobby.1ed15bf0.svg";